import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import SetPassword from "./pages/SetPassword";
import MagicLogin from "./pages/MagicLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ClientPortal from "./pages/ClientPortal";
import EmployeePortal from "./pages/EmployeePortal";
import SelectPortal from "./pages/SelectPortal";
import RequestDetail from "./pages/RequestDetail";
import { Toaster } from "./components/ui/toaster";

const Protected = ({ children, roles }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  if (user.email_verified === false) return <Navigate to="/verify-email" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/auth/:portal" element={<AuthPage />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/magic" element={<MagicLogin />} />
              <Route path="/set-password" element={<Protected roles={["admin", "client", "employee"]}><SetPassword /></Protected>} />
              <Route path="/dashboard" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
              <Route path="/portal" element={<Protected roles={["admin"]}><SelectPortal /></Protected>} />
              <Route path="/client" element={<Protected roles={["client", "admin"]}><ClientPortal /></Protected>} />
              <Route path="/employee" element={<Protected roles={["employee", "admin"]}><EmployeePortal /></Protected>} />
              <Route path="/request/:id" element={<Protected roles={["admin", "client", "employee"]}><RequestDetail /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
